var map = {
	"./apidays-2023-logo.png": "9165",
	"./apidays-day2-highlights.jpg": "7641",
	"./apidays-event-image.jpg": "6655",
	"./apidays-hongkong-2023-agenda-0830.png": "695d",
	"./apidays-hongkong-2023-agenda-0831.png": "337d",
	"./apidays-top-5-reasons.jpg": "db93",
	"./day-1/1.jpg": "0955",
	"./day-1/10.jpg": "42c2",
	"./day-1/11.jpg": "2ef6",
	"./day-1/12.jpg": "c5c7",
	"./day-1/13.jpg": "0faf",
	"./day-1/14.jpg": "4d1f",
	"./day-1/15.jpg": "2475",
	"./day-1/16.jpg": "b98b",
	"./day-1/17.jpg": "b209",
	"./day-1/18.jpg": "0f25",
	"./day-1/2.jpg": "a238",
	"./day-1/3.jpg": "4712",
	"./day-1/4.jpg": "4dab",
	"./day-1/5.jpg": "9d15",
	"./day-1/6.jpg": "79e4",
	"./day-1/7.jpg": "a335",
	"./day-1/8.jpg": "05b1",
	"./day-1/9.jpg": "1104",
	"./day-1/onsite-1.jpg": "3f84",
	"./day-2/1.png": "5771",
	"./day-2/2.png": "8394",
	"./day-2/3.png": "3d8b",
	"./day-2/4.png": "4ec3",
	"./day-2/5.png": "503c",
	"./day-2/6.png": "d18f",
	"./hkstp-location.jpg": "8537",
	"./luck-draw-banner.jpg": "a11b",
	"./oah-blog-cover.jpg": "afe6",
	"./the-top-5-challenges-in-implementing-api-strategy.jpg": "4fa7",
	"./video-cover.jpg": "9590"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2241";